import React, { useState, useEffect } from 'react';
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
} from '@mui/material';
import '../CSS/Documents.css';
import axios from 'axios';
import Menu from './Menu'; // Importez le menu fixe
import { useNavigate, useLocation } from 'react-router-dom'; // ✅ Ajout de useLocation
import apiUrl from '../config';
import Snackbar from '@mui/material/Snackbar'; // Pour les notifications
import Alert from '@mui/material/Alert'; // Pour le style des notifications
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { CircularProgress } from '@mui/material';  // Ajouter cette ligne pour importer CircularProgress
import LayoutDashboard from '../layout/LayoutDashboard';


const PageGestionDocuments = () => {
  const [documents, setDocuments] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState('all');
  const [isAdmin, setIsAdmin] = useState(false);
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });
  const [openDialog, setOpenDialog] = useState(false);
  const [docToDelete, setDocToDelete] = useState(null);
  const [loadingDocuments, setLoadingDocuments] = useState(true); // Pour les utilisateurs normaux
  const [loadingAdminDocuments, setLoadingAdminDocuments] = useState(false);  // Pour les admins après sélection d'un utilisateur
  const [loadingSelection, setLoadingSelection] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [loadingTable, setLoadingTable] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [userManuallySelected, setUserManuallySelected] = useState(false);
  const [openAddDialog, setOpenAddDialog] = useState(false);
const [typeDocument, setTypeDocument] = useState('');
const [otherType, setOtherType] = useState('');
const [file, setFile] = useState(null);
const [documentId, setDocumentId] = useState(null);
const [loadingUpload, setLoadingUpload] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    
    if (!token) {
        navigate('/login');  // Redirige vers la page de connexion si aucun token
    } else {
        // Vérifiez la validité du token ici
        const decodedToken = JSON.parse(atob(token.split('.')[1]));  // Décodage du token pour récupérer les informations
        const expirationTime = decodedToken.exp;  // Exemple d'expiration (si votre token contient un champ "exp")

        // Si le token est expiré, redirige vers la page de connexion
        if (expirationTime < Date.now() / 1000) {
            localStorage.removeItem('token');  // Supprime le token si expiré
            navigate('/login');  // Redirige vers la page de connexion si le token est expiré
        } else {
            setIsAdmin(decodedToken.role?.toUpperCase() === 'ADMIN');// Met à jour l'état de l'utilisateur
            const userId = decodedToken.user_id;
            
            const userIdFromProfile = location.state?.userId;
            const userIdToFetch = userIdFromProfile || decodedToken.user_id; // Prend l'ID du profil si présent, sinon celui du token
            setSelectedUser(userIdToFetch); // Met à jour l'utilisateur sélectionné
             

            // Afficher le message de chargement uniquement si on vient du profil
          if (userIdFromProfile) {
            setLoadingDocuments(true);
            setUserManuallySelected(true);
          }

            // Charger les documents de l'utilisateur ou tous les utilisateurs si admin
           if (decodedToken.role?.toUpperCase() === 'ADMIN') {
              fetchUsers().then(() => {
                const userIdFromProfile = location.state?.userId;
                if (userIdFromProfile) {
                  setSelectedUser(userIdFromProfile);
                  handleUserSelection(userIdFromProfile);
                } else {
                  setSelectedUser('all');
                  handleUserSelection('all');
                }
              });
            } else {
                // Pour les utilisateurs normaux, afficher le message de chargement dès l'entrée
                setLoadingDocuments(true);
            }
  
            // Message de chargement pendant la récupération des documents
            fetchUserDocuments(userIdToFetch)
            .then(() => {
                setLoadingDocuments(false); // Cache le message après chargement pour les utilisateurs normaux
            })
            .catch(() => {
                setLoadingDocuments(false);
                setNotification({
                    open: true,
                    message: 'Erreur lors du chargement des documents.',
                    severity: 'error',
                });
            });
        }
    }
  }, [navigate, location.state?.userId]); // Le useEffect est exécuté à chaque changement de 'navigate'

  const fetchUsers = async () => {
    try {
      const { data } = await axios.get(`${apiUrl}/cdi-users`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      const validUsers = data.filter(user => user && user.id);
      setUsers(validUsers);
      return Promise.resolve();  // permet le .then()
    } catch (error) {
      console.error('Erreur lors du chargement des utilisateurs:', error);
      return Promise.reject();
    }
  };  

  const handleUserSelection = (userId) => {
    setSelectedUser(userId);
    setLoadingAdminDocuments(true); // Affiche le message de chargement immédiatement après la sélection de l'utilisateur
    setLoadingSelection(true);  // Déclenche un indicateur de chargement supplémentaire
    setLoadingDocuments(true); // Ajout de ce drapeau pour assurer que le message de chargement reste actif
  
    fetchUserDocuments(userId)
    .then(() => {
        setLoadingAdminDocuments(false);
        setLoadingSelection(false);  // Cache le message après le chargement des documents
        setLoadingDocuments(false); // Désactive également ici pour éviter que le message de chargement persiste
    })
    .catch(() => {
        setLoadingAdminDocuments(false);
        setLoadingSelection(false);  // Cache également si une erreur se produit
        setLoadingDocuments(false);
        setNotification({
            open: true,
            message: 'Erreur lors du chargement des documents.',
            severity: 'error',
        });
    });
  };
  

  const fetchUserDocuments = async (userId) => {
    setLoadingDocuments(true); 
    setLoadingAdminDocuments(true);  
    setLoadingSelection(true);  
  
    try {
      const url = userId === 'all' 
        ? `${apiUrl}/documents/all` 
        : `${apiUrl}/documents/${userId}`;
  
      const { data } = await axios.get(url, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
  
      if (Array.isArray(data)) {
        setDocuments(data);
      } else {
        setDocuments([]);
      }
    } catch (error) {
      setDocuments([]);  
      setNotification({
        open: true,
        message: 'Erreur lors du chargement des documents.',
        severity: 'error',
      });
    } finally {
      setLoadingDocuments(false);  
      setLoadingAdminDocuments(false);  
      setLoadingSelection(false);  
    }
  };  

  const handleDownload = async (filename) => {
    try {
      const response = await axios.get(`${apiUrl}/documents/download/${filename}`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = urlBlob;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error('Erreur lors du téléchargement du document:', error);
      setNotification({
        open: true,
        message: 'Erreur lors du téléchargement du document.',
        severity: 'error',
      });      
    }
  };

  const handleConfirmDelete = async () => {
    setOpenDialog(false); // Fermer la boîte de dialogue
    setDeleting(true);    // Activer l'état de suppression
  
    // Affiche "Merci de patienter"
    setNotification({
      open: true,
      message: 'Merci de patienter, suppression en cours...',
      severity: 'info'
    });
  
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${apiUrl}/documents/${docToDelete}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      const decodedToken = JSON.parse(atob(token.split('.')[1]));
      if (isAdmin && selectedUser) {
        await fetchUserDocuments(selectedUser);
      } else {
        await fetchUserDocuments(decodedToken.user_id);
      }
  
      // Remplace le message par celui de succès
      setNotification({
        open: true,
        message: 'Document supprimé avec succès.',
        severity: 'success'
      });
  
    } catch (error) {
      setNotification({
        open: true,
        message: 'Erreur lors de la suppression du document.',
        severity: 'error'
      });
    } finally {
      setDeleting(false); // Fin de l'état de suppression
      setDocToDelete(null);
    }
  };  


const handleDelete = (docId) => {
  setDocToDelete(docId); // Stocke l'ID du document à supprimer
  setOpenDialog(true); // Ouvre la boîte de dialogue
};

const isValidUserValue = (val) => {
  if (val === 'all') return true;
  return users.some(user => user.id === val);
};

const handleUploadDocument = async () => {

if(!typeDocument || (typeDocument === "Autre" && !otherType) || !file){
setNotification({
open:true,
message:"Veuillez remplir tous les champs",
severity:"error"
});
return;
}

setLoadingUpload(true);

const formData = new FormData();
formData.append("document",file);
formData.append("type", typeDocument === "Autre" ? otherType : typeDocument);
formData.append("user_id", isAdmin ? selectedUser : JSON.parse(atob(localStorage.getItem("token").split('.')[1])).user_id);

try{

if(documentId){

await axios.put(`${apiUrl}/documents/${documentId}`,formData,{
headers:{ Authorization:`Bearer ${localStorage.getItem("token")}` }
});

setNotification({
open:true,
message:"Document modifié avec succès",
severity:"success"
});

}else{

await axios.post(`${apiUrl}/documents`,formData,{
headers:{ Authorization:`Bearer ${localStorage.getItem("token")}` }
});

setNotification({
open:true,
message:"Document ajouté avec succès",
severity:"success"
});

}

setOpenAddDialog(false);

fetchUserDocuments(isAdmin ? selectedUser : JSON.parse(atob(localStorage.getItem("token").split('.')[1])).user_id);

}catch(error){

setNotification({
open:true,
message:"Erreur lors de l'opération",
severity:"error"
});

}finally{
setLoadingUpload(false);
}

};

 return (
<LayoutDashboard>

<div className="dashboard-page">

<div className="welcome-section">
<h2>Gestion des Documents</h2>
<p>
Consultez, téléchargez ou ajoutez les documents des utilisateurs.
</p>
</div>

<Container maxWidth="lg">
        <Button
  variant="contained"
  sx={{ mb: 3, bgcolor: '#1f6391', color: 'white' }}
  onClick={() => {
    const token = localStorage.getItem('token');
    const decodedToken = JSON.parse(atob(token.split('.')[1]));
    const currentUserId = decodedToken.user_id;

    // ✅ Bloquer l'ajout si l'admin n'a pas sélectionné un utilisateur
    if (isAdmin && (selectedUser === 'all' || !selectedUser)) {
      setNotification({
        open: true,
        message: 'Veuillez sélectionner un utilisateur avant d’ajouter un document.',
        severity: 'error',
      });
      return;
    }

    const userIdToSend = isAdmin ? selectedUser : currentUserId;
    setDocumentId(null);
setTypeDocument('');
setOtherType('');
setFile(null);
setOpenAddDialog(true);
  }}
>
  + Ajouter document
</Button>

          <Box sx={{ mt: 4 }}>
          {isAdmin && (
  <>
    <Typography sx={{ fontWeight: 'bold', mb: 1, color: '#1f6391' }}>
      Sélectionnez un utilisateur
    </Typography>
    <Select
  value={isValidUserValue(selectedUser) ? selectedUser : 'all'} // ✅ Corrige ici
  onChange={(e) => {
    const userId = e.target.value;
    setUserManuallySelected(true);
    setSelectedUser(userId);
    fetchUserDocuments(userId);
    handleUserSelection(userId);
  }}
  fullWidth
  sx={{ mb: 2 }}
>
  <MenuItem value="all">Tous</MenuItem>
  {users.length > 0 ? (
    users.map((user) => (
      <MenuItem key={user.id} value={user.id}>
        {user.nom} {user.prenom}
      </MenuItem>
    ))
  ) : (
    <MenuItem disabled>Aucun utilisateur trouvé</MenuItem>
  )}
</Select>
  </>
)}          

            {/* Affichage du message de chargement */}
{/* Affichage du message de chargement */}
{/* Affichage du message de chargement */}
{/* Affichage du message de chargement */}
{(loadingDocuments || loadingAdminDocuments || loadingSelection) && (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2 }}>
    
    <Typography sx={{ ml: 2, fontSize: '1.2rem', fontWeight: 'bold', color: '#1f6391' }}>
      Merci de patienter...
    </Typography>
  </Box>
)}

{/* Affichage des documents une fois le chargement terminé */}
{!loadingDocuments && !loadingAdminDocuments && !loadingSelection && (
  documents.length > 0 ? (
    <TableContainer component={Paper} sx={{ mt: 4 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ color: '#1f6391', fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>Nom</TableCell>
            <TableCell style={{ color: '#1f6391', fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>Type</TableCell>
            <TableCell style={{ color: '#1f6391', fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>Date de création</TableCell>
            <TableCell style={{ color: '#1f6391', fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {documents.map((doc) => (
            <TableRow key={doc.id_document}>
              <TableCell>{doc.nom}</TableCell>
              <TableCell>{doc.type}</TableCell>
              <TableCell>{doc.date_de_creation}</TableCell>
              <TableCell>
                <Button variant="outlined" sx={{ color: '#2980b9', mt: 2 }} onClick={() => handleDownload(doc.nom)}>
                  Télécharger
                </Button>
                <Button
  variant="outlined"
  sx={{ color: '#2980b9', mt: 2, ml: 1 }}
  onClick={() => {
    const userIdToSend = isAdmin ? selectedUser : doc.id_utilisateur;
    setDocumentId(doc.id_document);

const typesStandards = ['Titre de Séjour','Carte Vitale','RIB','Contrat'];

if(typesStandards.includes(doc.type)){
  setTypeDocument(doc.type);
}else{
  setTypeDocument('Autre');
  setOtherType(doc.type);
}

setOpenAddDialog(true);
  }}
>
  Modifier
</Button>
                <Button variant="outlined" sx={{ color: '#2980b9', mt: 2 }} onClick={() => handleDelete(doc.id_document)}>
                  Supprimer
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : !loadingDocuments && !loadingAdminDocuments && !loadingSelection ? (
    <Typography sx={{ textAlign: 'center', mt: 4, fontSize: '1.2rem', fontWeight: 'bold', color: '#1f6391' }}>
      Aucun document disponible 
    </Typography>
  ) : null
)}

          </Box>
        </Container>

        <Snackbar
    open={notification.open}
    autoHideDuration={deleting ? null : 3000} // Ne ferme pas si on est en train de supprimer
    onClose={() => setNotification({ ...notification, open: false })}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Position en haut de la page
>
    <Alert
        severity={notification.severity}
        sx={{
            width: '100%',
            fontSize: '1.2rem',
            fontWeight: 'bold',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            borderRadius: '8px',
        }}
    >
        {notification.message}
    </Alert>
</Snackbar>
<Dialog
    open={openDialog}
    onClose={() => setOpenDialog(false)}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
>
    <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center', fontWeight: 'bold', color: '#1f6391' }}>
        Confirmation de suppression
    </DialogTitle>
    <DialogContent>
        <Typography id="alert-dialog-description" sx={{ textAlign: 'center', fontSize: '1.2rem' }}>
            Êtes-vous sûr de vouloir supprimer ce document ?
        </Typography>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'center', gap: '1rem' }}>
        <Button
            onClick={() => setOpenDialog(false)}
            variant="outlined"
            sx={{ color: '#1f6391', borderColor: '#1f6391' }}
        >
            Annuler
        </Button>
        <Button
            onClick={handleConfirmDelete}
            variant="contained"
            sx={{ bgcolor: '#1f6391', color: 'white' }}
        >
            Confirmer
        </Button>
    </DialogActions>
</Dialog>


      </div>

<Dialog
open={openAddDialog}
onClose={()=>setOpenAddDialog(false)}
fullWidth
maxWidth="sm"
>

<DialogTitle sx={{fontWeight:"bold",color:"#1f6391",textAlign:"center"}}>
{documentId ? "Modifier le document" : "Ajouter un document"}
</DialogTitle>

<DialogContent>

<Box sx={{display:"flex",flexDirection:"column",gap:2,mt:1}}>

<TextField
select
label="Type de document"
value={typeDocument}
onChange={(e)=>setTypeDocument(e.target.value)}
fullWidth
>

<MenuItem value="Titre de Séjour">Titre de Séjour</MenuItem>
<MenuItem value="Carte Vitale">Carte Vitale</MenuItem>
<MenuItem value="RIB">RIB</MenuItem>
<MenuItem value="Contrat">Contrat</MenuItem>
<MenuItem value="Autre">Autre</MenuItem>

</TextField>

{typeDocument==="Autre" && (

<TextField
label="Précisez le type"
value={otherType}
onChange={(e)=>setOtherType(e.target.value)}
fullWidth
/>

)}

<Button
variant="outlined"
component="label"
sx={{borderColor:"#1f6391",color:"#1f6391"}}
>

Choisir un fichier PDF

<input
type="file"
hidden
accept=".pdf"
onChange={(e)=>setFile(e.target.files[0])}
/>

</Button>

{file && (

<Typography sx={{fontSize:"0.9rem"}}>
{file.name}
</Typography>

)}

</Box>

</DialogContent>

<DialogActions sx={{justifyContent:"center",pb:2}}>

<Button
onClick={()=>setOpenAddDialog(false)}
variant="outlined"
sx={{borderColor:"#1f6391",color:"#1f6391"}}
>
Annuler
</Button>

<Button
variant="contained"
onClick={handleUploadDocument}
sx={{bgcolor:"#1f6391"}}
disabled={loadingUpload}
>

{loadingUpload ? "Merci de patienter..." : documentId ? "Valider modification" : "Ajouter document"}

</Button>

</DialogActions>

</Dialog>

      </LayoutDashboard>
  );
};

export default PageGestionDocuments;  
